export const joinClasses = (...classes: string[]) => {
  return classes.filter((item) => !!item).join(' ');
};
